// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t3jbx","colBig":"styles_colBig__2eC95","colSmall":"styles_colSmall__2dnPd"};